// GENERATED by `npm run api:generate` from openapi/openapi.json. Do not edit by hand.
import createClient from 'openapi-fetch';
/** The only way the web app talks to the API (REQ-05-003). */
export function createApiClient(options = {}) {
    return createClient(options);
}
//# sourceMappingURL=index.js.map